<!--
 * @Description: 客户下拉选择框
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2022-08-04 18:49:31
 * @LastEditors: mdb
-->
<template>
  <a-select
    v-model:value="data"
    style="width: 100%"
    @popupScroll="popupScroll"
    :showSearch="true"
    :filter-option="false"
    @search="search"
    placeholder="请选择"
    @change="change"
  >
    <a-select-option v-for="item in optionPage" :key="item.cosId" :value="item.cosId">{{
      item.arkCode ? `${item.customerName}(${item.arkCode})` : item.customerName
    }}</a-select-option>
  </a-select>
</template>
<script lang="ts" setup>
import { ref, onMounted, watch } from 'vue'
import type { SelectProps } from 'ant-design-vue'
import { findCusNameRelByPage } from '@/api/gucangSales/businessRuleSetting'
import { debounce } from 'lodash-es'
const props = defineProps({
  value: {
    type: String || Array
  }
})

const pageNumber = ref(1)
const data = ref()
const searchTxt = ref()
const emit = defineEmits(['update:value', 'selectData'])
const optionPage = ref<any[]>([])
// 赋值
watch(
  () => props.value,
  (v, prev) => {
    if (v && v !== data.value) {
      data.value = v
    } else if (!v) {
      data.value = undefined
    }
  },
  { immediate: true }
)
const change: SelectProps['onChange'] = (value) => {
  console.log('value: ', optionPage.value)
  if (optionPage.value) {
    const arr = optionPage.value.filter((item) => item.cosId === value)
    console.log('arr: ', arr)
    emit('selectData', arr[0].arkCode)
  }
  emit('update:value', value)
}
const popupScroll = (e: any) => {
  const { scrollHeight, scrollTop, clientHeight } = e.target
  if (scrollHeight - scrollTop === clientHeight) {
    pageNumber.value = pageNumber.value + 1
    fetch()
  }
}
const search = debounce((txt: string) => {
  searchTxt.value = txt
  optionPage.value = []
  fetch()
}, 500)
// 获取公司下拉列表
const fetch = () => {
  findCusNameRelByPage({
    pageNumber: pageNumber.value,
    pageSize: 100,
    content: searchTxt.value
  }).then((res) => {
    optionPage.value = [...optionPage.value, ...res.data.items]
  })
}
onMounted(() => {
  fetch()
})
</script>
<script lang="ts">
export default { name: 'CusSelect' }
</script>
